import { useDispatch } from "react-redux";
import { APP_VERSION } from "../config/config";
import { clearCart } from "../store/cartSlice";
import { persistor } from "../store/store";

// Reset site data when version changes
export const resetApp = async (dispatch) => {

  const storedVersion = localStorage.getItem("app_version");

  if (storedVersion !== APP_VERSION) {
    console.log(`Resetting site data due to version change (${storedVersion} → ${APP_VERSION})`);

    // redux persist
    await persistor.purge(); 

    // local storage
    localStorage.clear();

     // indexed DB
    const dbNames = await indexedDB.databases();
    dbNames.forEach((db) => {
      if (db.name) {
        indexedDB.deleteDatabase(db.name);
      }
    });

    localStorage.setItem("app_version", APP_VERSION);
    dispatch(clearCart());

    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
};
